import React, { useState, useRef } from "react";
import { Card, Grid, ButtonBase } from "@mui/material";
import { motion, AnimatePresence } from "framer-motion";
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";
import PieChart from "./PieChart";
import UsageCard from "./UsageCard";
import { useNavigate } from "react-router-dom";

const DynamicSiteCard = ({ site }) => {
  const [clicked, setClicked] = useState(false);
  const [cardRect, setCardRect] = useState(null);
  const cardRef = useRef(null);
  const navigate = useNavigate();

  const handleCardClick = () => {
    if (cardRef.current) {
      const rect = cardRef.current.getBoundingClientRect();
      setCardRect(rect);
    }
    setClicked(true);

    setTimeout(() => {
      navigate(`/site-dashboard/${site.id}`);
    }, 600); // match animation duration
  };

  return (
    <>
      <Card
        ref={cardRef}
        sx={{
          height: "100%",
          cursor: "pointer",
          position: "relative",
          overflow: "hidden",
          zIndex: 1,
        }}
      >
        <ButtonBase
          onClick={handleCardClick}
          sx={{
            width: "100%",
            height: "100%",
            textAlign: "left",
            padding: 2,
          }}
        >
          <VuiBox>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <VuiTypography variant="h6" color="white">
                  {site.name}
                </VuiTypography>
              </Grid>

              {/* Pie Chart */}
              <Grid item xs={12} sm={6} md={4}>
                <PieChart
                  Production_Hrs={site.Production_Hrs}
                  Idle_Hrs={site.Idle_Hrs}
                  Breakdown_Hrs={site.Breakdown_Hrs}
                  Offline_Hrs={site.Offline_Hrs}
                />
              </Grid>

              {/* Usage Cards */}
              <Grid item xs={12} sm={6} md={4}>
                <UsageCard
                  title="Daily Asphalt"
                  color="#0075FF"
                  value={Number(site.Asphalt_Day).toFixed(2)}
                  maxValue={0.1}
                  unit="T"
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <UsageCard
                  title="Daily RAP"
                  color="#D5ED9F"
                  value={Number(site.RAP_Total_Day).toFixed(2)}
                  maxValue={0.1}
                  unit="T"
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <UsageCard
                  title="Fuel"
                  color="#CAB773"
                  value={Number(site.Fuel_Total)}
                  maxValue={0.1}
                  unit="L"
                  tooltip="Yearly"
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <UsageCard
                  title="Gas"
                  color="#73CAC5"
                  value={Number(site.Gas_Total)}
                  maxValue={0.1}
                  unit="kW"
                  tooltip="Yearly"
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <UsageCard
                  title="Electricity"
                  color="#F0F477"
                  value={Number(site.Electric_Total)}
                  maxValue={0.1}
                  unit="kW"
                  tooltip="Yearly"
                />
              </Grid>
            </Grid>
          </VuiBox>
        </ButtonBase>
      </Card>

      <AnimatePresence>
        {clicked && cardRect && (
          <motion.div
            initial={{
              position: "fixed",
              top: cardRect.top,
              left: cardRect.left,
              width: cardRect.width,
              height: cardRect.height,
              opacity: 1,
              zIndex: 1000,
            }}
            animate={{
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              opacity: 0,
            }}
            exit={{
              opacity: 0,
            }}
            transition={{ duration: 0.6, ease: "easeInOut" }}
            style={{
              background: "#1e1e2f",
              borderRadius: 8,
              pointerEvents: "none",
            }}
          >
            {/* Expanded card content */}
            <VuiBox p={2}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <VuiTypography variant="h6" color="white">
                    {site.name}
                  </VuiTypography>
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  <PieChart
                    Production_Hrs={site.Production_Hrs}
                    Idle_Hrs={site.Idle_Hrs}
                    Breakdown_Hrs={site.Breakdown_Hrs}
                    Offline_Hrs={site.Offline_Hrs}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <UsageCard
                    title="Daily Asphalt"
                    color="#0075FF"
                    value={Number(site.Asphalt_Day).toFixed(2)}
                    maxValue={0.1}
                    unit="T"
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <UsageCard
                    title="Daily RAP"
                    color="#D5ED9F"
                    value={Number(site.RAP_Total_Day).toFixed(2)}
                    maxValue={0.1}
                    unit="T"
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <UsageCard
                    title="Fuel"
                    color="#CAB773"
                    value={Number(site.Fuel_Total)}
                    maxValue={0.1}
                    unit="L"
                    tooltip="Yearly"
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <UsageCard
                    title="Gas"
                    color="#73CAC5"
                    value={Number(site.Gas_Total)}
                    maxValue={0.1}
                    unit="kW"
                    tooltip="Yearly"
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <UsageCard
                    title="Electricity"
                    color="#F0F477"
                    value={Number(site.Electric_Total)}
                    maxValue={0.1}
                    unit="kW"
                    tooltip="Yearly"
                  />
                </Grid>
              </Grid>
            </VuiBox>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default DynamicSiteCard;
